import React, { useState, useRef} from 'react';
import './error404.css'
import ErrorLogo from '../../components/basicInfoForm/images/error.svg'
import ExpireLogo from '../../components/basicInfoForm/images/expiration-icon.png'
import Footer from '../../components/adminFooter/Footer';
import Button from '@mui/material/Button';
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import HomeContactUsModal from '../home/homeHeader/homeContactUsModal/homeContactUs';
import { useNavigate } from 'react-router-dom';

function Error404(props) {
  const [open, setOpen] = useState(false);
  const [hamburgerIsClicked, setHamburgerIsClicked] = useState(false)
  const history = useNavigate();
  const hamburger = useRef(0);

  const goToPreviousPage = (e) => {
    if (localStorage.getItem('role') === "Recruiter") {
      gotoHomePage()

    } else {
      history(-1)
    }

  }
  const gotoHomePage = (e) => {
    history("/")
  }
  const gotoLogin = (e) => {
    localStorage.clear();
    history("/signIn")

  }
  const openSupportModal = () => {
    setOpen(true);
  }
  const _modalClose = () => {
    setOpen(false);
  }

  const hamburgerClicked = () => {
    setHamburgerIsClicked(!hamburgerIsClicked)
  }


  return (

    <>

      {/*-------------> Nav Header Main <---------------- */}
      <div className="nav_bg_home home-specific-header">
        <div className="container w1200 nav_bg_home_section">
          <div className="nav_bg_left">

            <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
              <span><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></span>
            </li>

          </div>
          <div className="nav_bg_right">
            <ul className="navbar_home">
              <li className="special_hover cp" onClick={openSupportModal}><span>Contact Us</span></li>
            </ul>
          </div>
        </div>
      </div>

      {/*-------> Nav Header Mobile <------*/}
      <div className='nav_bg_home_responsive'>
        <div className="nav_bg_home_responsive-wrapper">
          <div className="home-top-nav">
            <li className='cp headerListStyleNone' onClick={() => gotoHomePage()}>
              <span><img src={recruiter_header_logo} className="nav_logo_home" alt='img' /></span>
            </li>
            <div className={hamburgerIsClicked ? "hamburgerIsClicked" : "hamburgerIsNotClicked"} ref={hamburger}>
              <ul className="navbar_home-responsive">
                <li className="special_hover cp" onClick={openSupportModal}><span>Contact Us</span></li>
              </ul>
            </div>
            <span className="icon" onClick={hamburgerClicked}>
              <i className="fa fa-bars"></i>
            </span>
          </div>
        </div>
      </div>


      {/* -------- Error Component --------- */}
      {/* {props.sessionExpired ? */}
      {(localStorage.getItem("sessionExpired")) ?

        <>
          <div className='error404-container'>
            <div className="error404_wrapper_main">
              <div className='errorLogoWrapper'><img src={ExpireLogo} alt='expireLogo' className="error404Logo"></img></div>
            </div>
            <div className="error404_wrapper_main">
              <div className='errorTextHeading' id="errorTextHeadingID">Your Session Has Expired</div>
            </div>
            <div className="error404_wrapper_main">
              <div className='errorTextParagrapgh'>Please Login Again To Continue.</div>
            </div>
            <div className="error404_wrapper_main">

              <Button variant="contained" className='error404ActionBtn' onClick={gotoLogin}>
                Login     </Button>
            </div>
          </div>
        </>
        :
        <>
          <div className='error404-container'>
            <div className="error404_wrapper_main">
              <div className='errorLogoWrapper'><span className='error4text'>4</span><img src={ErrorLogo} alt='errorLogo' className="error404Logo"></img><span className='error4text'>4</span></div>
            </div>
            <div className="error404_wrapper_main">
              <div className='errorTextHeading'>Page Not Found</div>
            </div>
            <div className="error404_wrapper_main">
              <div className='errorTextParagrapgh'>The page you are looking for  does not exist or was removed.</div>
            </div>
            <div className="error404_wrapper_main">

              <Button variant="contained" className='error404ActionBtn' onClick={goToPreviousPage}>
                Go Back </Button>
            </div>
          </div>
        </>}

      <HomeContactUsModal
        modalOpen={open}
        modalClose={_modalClose}
      />
      <Footer />
    </>
  )
}

export default Error404